import { Button, Checkbox, Space } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SwitchFilterProps, SwitchFilterValue } from './types';

import s from './SwitchFilter.module.scss';

const SwitchFilter: React.FC<SwitchFilterProps> = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
  close,
}) => {
  const { t } = useTranslation();

  const OPTIONS = React.useMemo(
    () => [
      { label: t('filter.yes'), value: 'true' },
      { label: t('filter.no'), value: 'false' },
    ],
    [t]
  );
  const currentValue: SwitchFilterValue = React.useMemo(() => {
    if (selectedKeys.length > 0 && typeof selectedKeys[0] === 'string') {
      try {
        return JSON.parse(selectedKeys[0]) as SwitchFilterValue;
      } catch {
        return { selected: [] };
      }
    }
    return { selected: [] };
  }, [selectedKeys]);

  const [selected, setSelected] = React.useState<string[]>(
    currentValue.selected.map(String)
  );

  React.useEffect(() => {
    setSelected(currentValue.selected.map(String));
  }, [currentValue]);

  const handleApply = React.useCallback(() => {
    if (selected.length > 0) {
      const filterValue: SwitchFilterValue = {
        selected: selected.map((v) => v === 'true'),
      };
      setSelectedKeys([JSON.stringify(filterValue)]);
    } else {
      setSelectedKeys([]);
    }
    
    confirm();
  }, [selected, setSelectedKeys, confirm]);

  const handleReset = React.useCallback(() => {
    setSelected([]);
    clearFilters?.();
  }, [clearFilters]);

  const handleChange = React.useCallback((checkedValues: string[]) => {
    setSelected(checkedValues);
  }, []);

  return (
    <div className={s.switchFilter}>
      <div className={s.switchFilter__content}>
        <Checkbox.Group
          value={selected}
          onChange={handleChange}
          options={OPTIONS}
          className={s.switchFilter__group}
        />
      </div>

      <Space className={s.switchFilter__buttons}>
        <Button size="small" onClick={handleReset}>
          {t('filter.reset')}
        </Button>
        <Button type="primary" size="small" onClick={handleApply}>
          {t('filter.apply')}
        </Button>
      </Space>
    </div>
  );
};

export default SwitchFilter;
